module.exports = __webpack_public_path__ + "img/nuxeobot.4f1cbb63.png";